import { setPrismMenu } from 'actions/ui';
import BlobImage from 'components/blobImage';
import { SystemText } from 'e4shared';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

export const Header = ({
    history,
    crumb,
    hideCrumb,
    title,
    prismProfile,
    extra,
    homepage,
    adminMenu,
    tracker,
    pathways,
    reviews,
    team,
    after,
}) => {
    const dispatch = useDispatch();

    if (!homepage) {
        crumb = crumb || { label: SystemText('Crumb/Default'), link: '/', menu: 'Home' };
    }

    if (pathways) {
        crumb = { label: SystemText('Crumb/Pathways'), link: '/pathways', menu: 'Pathways' };
    }

    if (reviews) {
        crumb = { label: SystemText('Crumb/Reviews'), link: '/reviews', menu: 'Reviews' };
    }

    if (team) {
        crumb = { label: SystemText('Crumb/Team'), link: '/my-team', menu: 'MyTeam' };
    }

    if (adminMenu) {
        crumb = { label: SystemText('Crumb/Admin'), link: '/admin', menu: 'Admin' };
    }

    if (tracker) {
        crumb = { label: SystemText('Crumb/Trackers'), link: '/organization', menu: 'Organisation' };
    }

    const setMenu = menu => {
        dispatch(setPrismMenu(menu));
    };

    const SearchBox = () => {
        const [search, setSearch] = React.useState('');

        const checkSubmit = e => {
            if (e.key === 'Enter') {
                history.push(`/search/${search}`);
            }
        };

        return (
            <div className="search-field">
                <i className="fa fa-search"></i>
                <input
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    onKeyDown={checkSubmit}
                    placeholder={SystemText('Header/Search/Placeholder')}
                />
            </div>
        );
    };

    return (
        <div className="header-wrapper">
            <div className="header" data-testid="page-header">
                <div className="crumb">
                    {!hideCrumb && crumb && (
                        <Link to={crumb.link} className="crumb-link" onClick={() => setMenu(crumb.menu)}>
                            <i className="fa fa-arrow-left"></i>
                            {crumb.label}
                        </Link>
                    )}
                </div>
                <SearchBox />
            </div>
            {prismProfile ? (
                <div className="flex flex-center mt10">
                    <div className="mr10">
                        <BlobImage
                            folder="avatar"
                            className="img-circle"
                            src={prismProfile.avatar}
                            initials={prismProfile.initials}
                            height="70"
                            width="70"
                        />
                    </div>
                    <div className="flex-grow flex flex-column">
                        <span className="header">
                            <h1 className="mb5">{prismProfile.full_Name}</h1>
                        </span>
                        <div>{prismProfile.job_Title}</div>
                    </div>
                </div>
            ) : (
                <div className={`header flex flex-center ${extra ? 'mt10' : ''}`}>
                    <h1 className="flex-grow">{title}</h1>
                    {extra && <div>{extra()}</div>}
                </div>
            )}
            {after && <div className="mt20">{after()}</div>}
        </div>
    );
};

export default Header;
